import capitalize from '@/support/filters/capitalize';

const newQueryTagFields = {
  computed: {
    /**
     * The name from tag field.
     *
     * @returns {string|*}
     */
    tagFieldName() {
      if (this.tag === 'cpf' || this.tag === 'cnpj') {
        return 'cpfCnpj';
      }

      return this.tag;
    },

    /**
     * The label from tag field.
     *
     * @returns {string}
     */
    tagFieldLabel() {
      if (this.tag === 'cpf' || this.tag === 'cnpj') {
        return this.tag.toUpperCase();
      }

      return capitalize(this.tag);
    },

    /**
     * Has tag field.
     *
     * @returns {boolean}
     */
    hasTagField() {
      return this.tag !== 'vehicles' && this.tag !== 'properties';
    },
  },
};

export default newQueryTagFields;
